import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FilterCheckbox } from "@/components/common/Filters"
import { ChangeLogSubCategory } from "@/graphql/codegen/graphql"
import { CHANGE_LOG_SUB_CATEGORY_LABELS } from "@/screens/ChangeLog/constants"
import type { ChangeLogSearchFilters } from "@/screens/ChangeLog/stores/useChangeLogSearchStore"

const changeLogSubCategoryList = Object.values(ChangeLogSubCategory)

interface SubCategoryFilterProps {
  onFilterChange: (name: keyof ChangeLogSearchFilters, value: unknown) => void
}

const ChangeLogSubCategoryFilter: FC<SubCategoryFilterProps> = ({ onFilterChange }) => {
  const { control, watch } = useFormContext()
  const subCategoriesValue = watch("subcategories") || []

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {changeLogSubCategoryList.map((changeLogSubCategory) => (
        <FilterCheckbox
          key={changeLogSubCategory}
          label={CHANGE_LOG_SUB_CATEGORY_LABELS[changeLogSubCategory]}
          value={changeLogSubCategory}
          control={control}
          name='subcategories'
          values={subCategoriesValue}
          onFilterChange={(values: string[]) => onFilterChange("subcategories", values)}
        />
      ))}
    </Box>
  )
}

export default ChangeLogSubCategoryFilter
